import * as K from './QuotationsConstants';
import Fuse from 'fuse.js';
import immutable from 'object-path-immutable';

import floopback from '../../../lib/floopback';
import { toast } from 'react-toastify';

var Quotations = new floopback('quotations');

export function setState(value) {
  return {
    type: K.SETSTATE,
    payload: value,
  };
}

export function stateInit(value) {
  return {
    type: K.STATEINIT,
  };
}

export function onChange(path, value) {
  return {
    type: K.ON_CHANGE,
    payload: {
      path: path,
      value: value,
    },
  };
}

export function find(params) {
  let _this = this;
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND,
      payload: Quotations.find(params),
    }).then(
      function (result) {
        _this.searchTable(getState().Quotations.search);
      },
      (err) => {
        console.error(err.slack);
        toast.error(err.message);
      }
    );
  };
}

export function findById(id) {
  return async (dispatch, getState) => {
    var CurrentQuotation = await Quotations.findById(id, {
      include: ['client'],
    });

    var newQuotation = immutable.set(
      getState().Quotations,
      'id',
      CurrentQuotation.id
    );
    newQuotation = immutable.set(
      newQuotation,
      ['clientInformation', 'id'],
      CurrentQuotation.clientId
    );
    newQuotation = immutable.set(
      newQuotation,
      'clientId',
      CurrentQuotation.clientId
    );
    newQuotation = immutable.set(
      newQuotation,
      'clientInformation',
      CurrentQuotation.client
    );

    newQuotation = immutable.set(newQuotation, 'optionsSelect.client', [
      {
        value: CurrentQuotation.client.id,
        label:
          (CurrentQuotation.client.firstName
            ? CurrentQuotation.client.firstName
            : '') +
          ' ' +
          (CurrentQuotation.client.lastName
            ? CurrentQuotation.client.lastName
            : ''),
      },
    ]);
    newQuotation = immutable.set(newQuotation, 'folio', CurrentQuotation.folio);
    newQuotation = immutable.set(
      newQuotation,
      'generalQuotation',
      CurrentQuotation.generalQuotation
    );
    newQuotation = immutable.set(newQuotation, 'dates', CurrentQuotation.dates);
    newQuotation = immutable.set(
      newQuotation,
      'comments',
      CurrentQuotation.comments
    );
    newQuotation = immutable.set(
      newQuotation,
      'flights',
      CurrentQuotation.flights
    );

    if (CurrentQuotation.lodgings.length > 0) {
      CurrentQuotation.lodgings.sort((a, b) =>
        a.hotel.name > b.hotel.name ? 1 : b.hotel.name > a.hotel.name ? -1 : 0
      );
    }

    newQuotation = immutable.set(
      newQuotation,
      'lodgings',
      CurrentQuotation.lodgings
    );
    newQuotation = immutable.set(
      newQuotation,
      'otherServicesQuotation',
      CurrentQuotation.otherServices
    );
    newQuotation = immutable.set(
      newQuotation,
      'packages',
      CurrentQuotation.packages
    );
    newQuotation = immutable.set(newQuotation, 'loading', false);

    dispatch({
      type: K.SETSTATE,
      payload: newQuotation,
    });
  };
}

export function create(formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.CREATE + '_PENDING', payload: formData });
      Quotations.create(formData)
        .then(function (data) {
          dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.CREATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function update(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
      Quotations.update(id, formData)
        .then(function (data) {
          dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.DELETE + '_PENDING' });
      Quotations.delete(id)
        .then(function (data) {
          dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.DELETE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function changeTable(feature, value) {
  return (dispatch, getState) => {
    dispatch({
      type: K.CHANGE_TABLE,
      payload: {
        feature: feature,
        value: value,
      },
    });
  };
}

export function searchTable(search) {
  return (dispatch, getState) => {
    var options = {
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        'generalQuotation.interest',
        'generalQuotation.destination',
        'client.firstName',
        'client.lastName',
        'folio',
      ],
    };

    var fuse = new Fuse(getState().Quotations.data, options);
    let result = fuse.search(search);

    dispatch({
      type: K.SEARCH_TABLE,
      payload: {
        search: search,
        searchData: result,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./src/views/Quotations/redux/QuotationsActions.jsx